import React from 'react';

import ItemOptionManageQuestionPresentation from './ItemOptionManageQuestionPresentation';

export default class ItemOptionManageQuestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllTextOption: false,
        };
    }

    handleShowAllTextOption(currentShowAllTextOption) {
        this.setState({ showAllTextOption: !currentShowAllTextOption });
    }

    render() {
        const {
            option,
            handleRemoveItemsOptionQuestion,
            handleSelectCorrectOptionQuestion,
            handleEnableItemsOptionQuestion,
            enableEditMode,
            editMode,
        } = this.props;
        const { showAllTextOption } = this.state;
        return (
            <ItemOptionManageQuestionPresentation
                option={option}
                handleSelectCorrectOptionQuestion={
                    handleSelectCorrectOptionQuestion
                }
                handleRemoveItemsOptionQuestion={
                    handleRemoveItemsOptionQuestion
                }
                handleEnableItemsOptionQuestion={
                    handleEnableItemsOptionQuestion
                }
                handleShowAllTextOption={this.handleShowAllTextOption.bind(
                    this,
                )}
                showAllTextOption={showAllTextOption}
                enableEditMode={enableEditMode}
                editMode={editMode}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/manage-question/components/ItemOptionManageQuestion/index.js